<template>
  <AppAside class="aside-for-links">
    <template v-slot:title>
      <h1>For more information on what you need to bring to your appointment:</h1>
    </template>
    <ul class="app-bullet-list">
      <li>
        <a href="http://www.dmv.ri.gov/forms/" target="_blank"
           rel="noopener noreferrer">Forms and Fees</a>
        <img src="@ridmv/web-themes/images/icons/external-link-alt-solid.svg" alt="External link">
      </li>
      <li>
        <a href="http://www.dmv.ri.gov/forms/checklists/index.php" target="_blank"
           rel="noopener noreferrer">Checklists</a>
        <img src="@ridmv/web-themes/images/icons/external-link-alt-solid.svg" alt="External link">
      </li>
      <li>
        <a href="http://www.dmv.ri.gov/" target="_blank"
           rel="noopener noreferrer">RI DMV Home Page</a>
        <img src="@ridmv/web-themes/images/icons/external-link-alt-solid.svg" alt="External link">
      </li>
    </ul>
  </AppAside>
</template>

<script setup>
import AppAside from './AppAside.vue';

defineOptions({
  name: 'AsideForLinks',
});
</script>


<style scoped lang="scss">
.aside-for-links {
  img {
    margin-left: 0.5em;
    width: 0.75rem;
  }
}
</style>
